module.exports = __webpack_public_path__ + "img/mbanner4.551f5f6c.jpg";